import styles from "./index.module.css";
import ChartBase from "./Chart/ChartBase";
import { useAdsMap } from "./Chart/useAdsMap";
import StatCard from "./Card";
import {Banknote, Calculator, ConciergeBell, ConciergeBellIcon, Monitor, Mouse, ScreenShare, Users, CheckSquare, Clock, Building2, Earth, Calendar, BellPlus, ScanEye, Eye, Calendars, Smartphone, Globe, Cog, ArrowBigUp, LucideArrowDown, LucideArrowUp, LucideCalendarClock} from "lucide-react"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, Tooltip as ChartTooltip, Legend, PointElement } from "chart.js";
import ReactTooltip from 'react-tooltip';
import "flatpickr/dist/themes/airbnb.css";
import React, { useEffect, useState, useMemo, useRef } from "react"
import { Link, useLocation, useParams } from "react-router-dom"
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Spinner from 'react-bootstrap/Spinner';
import ChartSimple from "./Chart/ChartSimple";
import stylesReport from "./report.module.css";
import { get } from "mongoose";
// const CLIENT_ID = "795120460818-gie3v2di14h5ed8vpinqndkao7iv7frk.apps.googleusercontent.com";
// const REDIRECT_URI = "http://localhost:3000/en/test"
import { CurrencyConverter } from "./Unit/CurrencyConverter";
import  useCurrencyRate  from "./Unit/useCurrencyRate";
import LoadingModal from "./Unit/LoadingModal";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ChartTooltip,
  Legend,
  PointElement
);
//https://apidojo-booking-v1.p.rapidapi.com/properties/list-by-map?room_qty=1&guest_qty=2&bbox=21.0015,21.05,105.78,105.85&search_id=none&price_filter_currencycode=VND&languagecode=en-us&travel_purpose=leisure&order_by=price&offset=0&arrival_date=2026-06-19&departure_date=2026-06-20
export default function Dashboard() {
     const [ga4data, setGA4Data] = useState(null);
     const [ga4FormattedData, setGA4FormattedData] = useState(null);
     const [metaData, setMetaData] = useState(null);
     const [metaAdsData, setMetaAdsData] = useState({})
     const {t, i18n} = useTranslation()
     const [propertyID, setPropertyID] = useState("366123786")
     const [isLoading, setIsLoading] = useState(false)
     const [startDate, setStartDate] = useState(() =>
             dayjs().startOf("month").format("YYYY-MM-DD")
           );
     
           const [endDate, setEndDate] = useState(() =>
             dayjs().format("YYYY-MM-DD")
           );
    
     const [impressions, setImpressions] = useState(0);
     const [clicks, setClicks] = useState(0);
     const [conversion, setConversion] = useState(0);
     const [costs, setCosts] = useState(0);
     const [cpc, setCPC] = useState(0)
     const [ctr, setCTR] = useState(0)
     const [cvr, setCVR] = useState(0)
     const [ReservationData, setReservationData] = useState(null);
     const [otherGA4Data, setOtherGA4Data] = useState(null);
     const [adsData, setAdsData] = useState([]);
     const [currency, setCurrency] = useState("VND");
     const { usdRate, timeLastUpdated } = useCurrencyRate();
     const [resource, setResource] = useState("20838761231");
     const adsMap = useAdsMap(adsData)
     const [compareData, setCompareData] = useState(null)
     const [realReservation, setRealReservation] = useState(null)
     const prevStartDate = dayjs(startDate)
              .subtract(1, "month")
              .startOf("month") 
              .format("YYYY-MM-DD");

          const prevEndDate = dayjs(endDate)
              .subtract(1, "month")
              .format("YYYY-MM-DD");


  const countRestMetric = (dataSource, metricIndex) => {
  return dataSource
  .reduce((sum, row) => {
    const value = Number(row?.metricValues?.[metricIndex]?.value || 0)
    return sum + value
  }, 0)
}
useEffect(() => {
   const getRealReservationDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/website/compare/${dayjs(startDate).format("YYYY-MM")}/${dayjs(endDate).subtract(1, 'month').format("YYYY-MM")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setRealReservation(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getCompareDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/compare/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}/${prevStartDate}/${prevEndDate}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setCompareData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
    if (!startDate || !endDate) return;
      getRealReservationDataGA4()
      getCompareDataGA4()
}, [startDate, endDate, prevEndDate, prevStartDate, propertyID]);
const useRestMetricStats = (data, metricIndex) => {
  return useMemo(() => {
   if (!data?.rows?.length) return 0;
   return countRestMetric(data.rows, metricIndex)
  }, [data, metricIndex])
}
  const reservationCompleted = useRestMetricStats(ReservationData, 0)
 const getDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/reservations/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setReservationData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getOtherDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/otherData/${propertyID}?startDate=${dayjs(startDate).format("YYYY-MM-DD")}&endDate=${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setOtherGA4Data(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 

    useEffect(() => {
      if (!adsData?.length) return;

      let impressions = 0;
      let clicks = 0;
      let cost = 0;

      for (const row of adsData) {
        impressions += Number(row.metrics?.impressions || 0);
        clicks += Number(row.metrics?.clicks || 0);
        cost += Number(row.metrics?.costMicros || 0);
      }

      cost = cost / 1_000_000; // micros → tiền

      const ctr = impressions > 0 ? (clicks / impressions) * 100 : 0;
      const cpc = clicks > 0 ? cost / clicks : 0;

      setImpressions(impressions);
      setClicks(clicks);
      setCosts(cost);
      setCTR(ctr);
      setCPC(cpc);
      setCVR(cvr);

    }, [adsData]);


const fetchAdsData = async () => {
  setIsLoading(true);

  try {
    const res = await fetch(
      `/api/googleAds/ads-data/campaign/${startDate}/${endDate}`
    );
 
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await res.json();
      if(responseData){
        setIsLoading(false) 
        setAdsData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
  }

const fetchAdsConversionData = async () => {
  setIsLoading(true);

  try {
    const res = await fetch(
      `/api/googleAds/ads-conversions/${startDate}/${endDate}`
    );
 
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await res.json();
      if(responseData){
        setIsLoading(false) 
        const total = Object.entries(responseData)
        // .filter(([key]) => !key.includes("Phnom Penh"))
        .reduce((sum, [, value]) => sum + Number(value), 0);

        setConversion(total)
      }

    } catch (error) {
      console.error('Error:', error);
  }
  }


useEffect(() => {
  // if (!isLoggedIn) return;
  if (!startDate || !endDate) return;

  fetchAdsData();
  fetchAdsConversionData();
  getDataGA4();
  getOtherDataGA4();
  
}, [startDate, endDate, propertyID]);


  const flatData = useMemo(() => {
  if (!otherGA4Data || typeof otherGA4Data !== "object") return [];

  return Object.values(otherGA4Data).flat();
}, [otherGA4Data]);

  
const countMetrics = (dataSource, dimensionIndex) => {
  return dataSource.reduce((acc, row) => {
    const keyData = row?.dimensionValues?.[dimensionIndex]?.value ;
    acc[keyData] = (acc[keyData] || 0) + 1
    return acc;
  }, {});
};
const browserStats = useMemo(() => {
  return countMetrics(flatData, 4);
}, [flatData]);
const deviceStats = useMemo(() => {
  return countMetrics(flatData, 3);
}, [flatData]);
const osStats = useMemo(() => {
  return countMetrics(flatData, 5);
}, [flatData]);


useEffect(() => {
   const getMetricDataGA4 = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(`/api/ga4/overview-by-date/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const responseData = await response.json();
        if(responseData){
          setIsLoading(false) 
          setGA4Data(responseData.rows)
        }
  
      } catch (error) {
        console.error('Error:', error);
    }
  }; 
const getMetaAdsData = async () => {
  try {
    setIsLoading(true);
    const res = await fetch(`/api/meta/data/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`);

    if (!res.ok) {
      throw new Error("Network response was not ok");
    }

    const responseData = await res.json();
    if (responseData) {
      setIsLoading(false);
      const excludedKeywords = ["recruit", "recruitment", "tuyển dụng", "tuyển"];
      const filteredData = responseData.data?.filter(row => {
        const campaignName = (row.campaign_name || "").toLowerCase();
        return !excludedKeywords.some(keyword => campaignName.includes(keyword.toLowerCase()));
      });
      setMetaData(filteredData?.length ? { data: filteredData } : null);
    }
  } catch (error) {
    setIsLoading(false);
    console.error("Error:", error);
  }
};


// const getMarketData = async () => {
//   try {
//     setIsLoading(true);
//     const res = await fetch(`/api/market/data/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`);

//     if (!res.ok) {
//       throw new Error("Network response was not ok");
//     }

//     const responseData = await res.json();
//     if (responseData) {
//       console.log(responseData);
      
//     }
//   } catch (error) {
//     setIsLoading(false);
//     console.error("Error:", error);
//   }
// };
// getMarketData()

        if(startDate && endDate){
          getMetaAdsData()
          getMetricDataGA4()
        }
      }, [startDate, endDate])
      const calculateMetaData = (data) => {
        if (!data?.length) {
          return {
            impressions: 0,
            clicks: 0,
            cost: 0,
            ctr: 0,
            cpc: 0,
            conversion: 0,
            cvr: 0,
            cpa: 0
          };
        }

        let impressions = 0;
        let clicks = 0;
        let cost = 0;
        let conversion = 0;

        for (const row of data) {

          impressions += Number(
            row.impressions || 0
          );

          clicks += Number(
            row.clicks || 0
          );

          cost += Number(
            row.spend || 0
          );

          // conversion
          const purchaseAction =
            row.actions?.find(
              action =>
                action.action_type.includes("offsite_conversion.custom")
            );

          conversion += Number(
            purchaseAction?.value || 0
          );
        }

        const ctr =
          impressions > 0
            ? (clicks / impressions) * 100
            : 0;

        const cpc =
          clicks > 0
            ? cost / clicks
            : 0;

        const cvr =
          clicks > 0
            ? (conversion / clicks) * 100
            : 0;

        const cpa =
          conversion > 0
            ? cost / conversion
            : 0;

        return {
          impressions,
          clicks,
          cost,
          ctr,
          cpc,
          conversion,
          cvr,
          cpa
        };
      };
          useEffect(() => {
            const data = calculateMetaData(metaData?.data)
            setMetaAdsData(data)
            
          },[startDate, endDate, metaData])
         const formatGA4ChartData = (rows) => {
      if (!rows) return {};

      return rows.reduce((acc, item) => {
        const rawDate = item.dimensionValues[0].value;

        const formattedDate = `${rawDate.slice(0, 4)}-${rawDate.slice(
          4,
          6
        )}-${rawDate.slice(6, 8)}`;

        acc[formattedDate] = {
          activeUsers: Number(item.metricValues[0]?.value || 0),
          screenPageViews: Number(item.metricValues[1]?.value || 0),
          eventCount: Number(item.metricValues[2]?.value || 0),
          sessions: Number(item.metricValues[3]?.value || 0),
          totalUsers: Number(item.metricValues[4]?.value || 0),
          newUsers: Number(item.metricValues[5]?.value || 0),
        };

        return acc;
      }, {});
};
  useEffect(() =>{
    const data = formatGA4ChartData(ga4data)
    setGA4FormattedData(data)
  }, [ga4data])
    return (
      <>
<div style={{ background: '#fff', color: '#222' }}> 
     <div style={{ padding: 30, paddingBottom: 0, backgroundColor:"#fff" }}>
        <div className="d-flex justify-content-between mt-5">
          <div className="d-flex">
             <div style={{marginRight: 10, width: 'fit-content'}}>
                   <Flatpickr 
                     value={startDate}
                       options={{
                       dateFormat:'Y-m-d'}} 
                        className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                         placeholder={t('booking.date_in')} 
                         onChange={(dates)=>{
                         setStartDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                      }} />
             </div>
               <div style={{marginRight: 10, width: 'fit-content'}}>
                    <Flatpickr 
                            value={endDate}
                            options={{
                              minDate: dayjs(startDate).format("YYYY-MM-DD"),
                              dateFormat:'Y-m-d'}} 
                            className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                            placeholder={t('booking.date_out')} 
                            onChange={(dates) =>{
                              setEndDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                            }} />
               </div>
               <div style={{marginRight: 10, width: 'fit-content'}}>
                <button 
                className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                onClick={() => {
                  const lastMonthStart = dayjs(startDate).subtract(1, "month").startOf("month").format("YYYY-MM-DD");
                  const lastMonthEnd = dayjs(endDate).subtract(1, "month").endOf("month").format("YYYY-MM-DD");
                  setStartDate(lastMonthStart);
                  setEndDate(lastMonthEnd);
                }}>
                  Last Month
                </button>
               </div>
          </div>
        <div>
           <div className="d-flex justify-content-center align-items-center" style={{ gap: 15, background: "#fff", padding: "12px 20px", borderRadius: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "fit-content", margin: "20px auto" }} >
            <div style={{ fontSize: 18, fontWeight: 600, color: "#333" }}>Currency</div>
            {/* VND */}
            <label htmlFor="vnd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: 0, background: currency === "VND" ? "#482979" : "#f5f5f5", color: currency === "VND" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
              <input
                type="radio"
                id="vnd"
                value="VND"
                checked={currency === "VND"}
                onChange={(e) =>
                  setCurrency(e.target.value)
                }
                style={{ display: "none" }}
              />
              ₫ VND
            </label>
            <label htmlFor="usd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginLeft: 0, background: currency === "USD" ? "#482979" : "#f5f5f5", color: currency === "USD" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
              <input
                type="radio"
                id="usd"
                value="USD"
                checked={currency === "USD"}
                onChange={(e) =>
                  setCurrency(e.target.value)
                }
                style={{ display: "none" }}
              />
              $ USD
            </label>

          </div>
          <div style={{fontSize: 20, fontWeight: 'bold',color: "#482979"}}>Rate: 1$ = {Intl.NumberFormat("de-DE", { style: "currency", currency: "VND" }).format(usdRate)}</div>
            <div style={{fontSize: 15, fontWeight: 'bold',color: "#000"}}>Last Updated: {new Date(timeLastUpdated).toLocaleString()}</div>
        </div>
            </div> 
        </div>
       
           </div>
      {isLoading && (
           <LoadingModal />
          )}
        <div className="d-flex align-items-center">
            <img src="https://cdn-icons-png.flaticon.com/512/2875/2875421.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
          <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Ads</div>
          </div>
        <div className="container-fluid pl-5 pr-5">
              <div className='row'>
                <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper} data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="IMPRESSIONS"
                                    value={Intl.NumberFormat('de-DE').format(impressions)}
                                    icon={<Monitor size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`} >
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.click')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}                            
                                    fontValue={60}
                                    title="CLICKS"
                                    value={Intl.NumberFormat('de-DE').format(clicks)}
                                    icon={<Mouse size={30} color="#16a34a" />}
                                    // gradientFrom="#4b0082"
                                    // gradientTo="#8a2be2"
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="CONVERSIONS"
                                    value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(conversion))}
                                    icon={<ConciergeBell size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="COST"
                                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(CurrencyConverter(costs, currency, usdRate))}
                                    icon={<Banknote size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                </div>
                <div className='row'>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.ctr')} data-for="marketing">
                                  <StatCard
                                    unit="%"
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="CTR"
                                    value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(ctr)}
                                    icon={<Calculator size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cpc')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="CPC"
                                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency }).format(CurrencyConverter(cpc, currency, usdRate))}
                                    icon={<Calculator size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                  <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cvr')} data-for="marketing">
                                  <StatCard
                                    unit="%"
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="CVR"
                                    value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(clicks > 0 ? (conversion / clicks) *100 : 0)}
                                    icon={<ConciergeBellIcon size={30} color="#16a34a" />}
                                  gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                  <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
                <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cpa')} data-for="marketing">
                                  <StatCard
                                    height={320}
                                    fontTitle={40}
                                    fontValue={60}
                                    title="CPA"
                                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(CurrencyConverter(conversion > 0 ? costs / conversion : 0, currency, usdRate))}
                                    icon={<Calculator size={30} color="#16a34a" />}
                                    gradientFrom="#16a34a"
                                    gradientTo="#065f46"
                                  />
                            </div>
                </div>
                    
              </div>
              <ReactTooltip id = 'marketing' style={{
                  fontSize: 20,
                  maxWidth: 400,
                  whiteSpace: "pre-line",
                  backgroundColor: "#000",
                  borderRadius: 10,
                  zIndex: 99999
                }}/>
            </div>
            <div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/732/732204.png" alt="GA4" style={{width: 60, height: 60, marginLeft: 30}}/>
              <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Analytics</div>
                  </div>
        <div className="container-fluid pl-5 pr-5" >
              <div className="row">
                  <div className="col-md-3 p-3">
                  <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.ga4Reservation')} data-for="marketing">
                      <StatCard
                        height={320}
                        fontTitle={40}
                        fontValue={60}
                        title="GA4 Reservation"
                        value={Intl.NumberFormat('de-DE').format(reservationCompleted)}
                        icon={<ConciergeBell size={20} color="#FF8A00" />}
                        // gradientFrom="#16a34a"
                        // gradientTo="#065f46"
                        gradientFrom="#ffa743"
                        gradientTo="#b3350f"
                      />
                    <div>
                  </div>
                  </div>
                </div>
                <div className="col-md-3 p-3">
                  <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.webReservation')} data-for="marketing">
                      <StatCard
                        height={320}
                        fontTitle={40}
                        fontValue={60}
                        title="Web Reservation"              
                        value={Intl.NumberFormat('de-DE').format(realReservation?.totalMonth1)}
                        icon={<ConciergeBell size={20} color="#FF8A00" />}
                        checkColor={realReservation?.trend === 'up' ? "green" : "red"}
                        checkIcon={realReservation?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}       
                        gradientFrom="#ffa743"
                        gradientTo="#b3350f"
                      />
                    <div>
                  </div>
                  </div>
                </div>
                <div className="col-md-3 p-3">
                  <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.totalUser')} data-for="marketing">
                      <StatCard
                        height={320}
                        fontTitle={40}
                        fontValue={60}
                        title="Total Users"
                        value={Intl.NumberFormat('de-DE').format(compareData?.overview?.totalUsers?.current)}
                        icon={<Users size={20} color="#FF8A00" />}
                        gradientFrom="#ffa743"
                        gradientTo="#b3350f"
                      />
                </div>
                </div>
                  <div className="col-md-3 p-3">
                  <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.session')} data-for="marketing">
                      <StatCard
                        height={320}
                        fontTitle={40}
                        fontValue={60}
                        title="Sessions"
                        value={Intl.NumberFormat('de-DE').format(compareData?.overview?.sessions?.current)}
                        icon={<Clock size={20} color="#FF8A00" />}
                        gradientFrom="#ffa743"
                        gradientTo="#b3350f"
                      />
                </div>
                </div>
                <ReactTooltip id = 'marketing' style={{
                        fontSize: 20,
                        maxWidth: 400,
                        whiteSpace: "pre-line",
                        backgroundColor: "#000",
                        borderRadius: 10,
                        zIndex: 99999
                      }}/>


              </div>
            </div>
        <div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/6033/6033716.png" alt="Meta" style={{width: 60, height: 60, marginLeft: 30}}/>
            <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Meta Ads</div>
                  </div>
    <div className="container-fluid pl-5 pr-5" >
          <div className="row">
              <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="Impressions"
                    value={Intl.NumberFormat('de-DE').format(metaAdsData?.impressions)}
                    icon={<Monitor size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
                <div>
              </div>
              </div>
            </div>
            <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.click')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="Clicks"              
                    value={Intl.NumberFormat('de-DE').format(metaAdsData?.clicks)}
                    icon={<Mouse size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
                <div>
              </div>
              </div>
            </div>
            <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="Conversions"
                    value={Intl.NumberFormat('de-DE').format(metaAdsData?.conversion)}
                    icon={<ConciergeBell size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
              <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="Cost"
                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(CurrencyConverter(metaAdsData?.cost, currency, usdRate))}
                    icon={<Banknote size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
             <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.cpc')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="CPC"
                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency }).format(CurrencyConverter(metaAdsData?.cpc, currency, usdRate))}
                    icon={<Banknote size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
             <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.ctr')} data-for="marketing">
                  <StatCard
                    unit="%"
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="CTR"
                    value={Intl.NumberFormat('de-DE').format(metaAdsData?.ctr)}
                    icon={<Banknote size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
             <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.cvr')} data-for="marketing">
                  <StatCard
                    unit="%"
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="CVR"
                    value={Intl.NumberFormat('de-DE').format(metaAdsData?.cvr)}
                    icon={<Banknote size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
             <div className="col-md-3 p-3">
              <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.googleAds.cpa')} data-for="marketing">
                  <StatCard
                    height={320}
                    fontTitle={40}
                    fontValue={60}
                    title="CPA"
                    value={Intl.NumberFormat("de-DE", {style: "currency", currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(CurrencyConverter(metaAdsData?.cpa, currency, usdRate))}
                    icon={<Banknote size={20} color="#0866FF" />}
                    gradientFrom="#0866FF"
                    gradientTo="#0431a6"
                  />
            </div>
            </div>
            <ReactTooltip id = 'marketing' style={{
                    fontSize: 20,
                    maxWidth: 400,
                    whiteSpace: "pre-line",
                    backgroundColor: "#000",
                    borderRadius: 10,
                    zIndex: 99999
                  }}/>


          </div>
        </div>
<div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/2875/2875421.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
          <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Ads Chart</div>
          </div>
       <div className="container-fluid pl-5 pr-5 mt-5" >
        <div className="row">
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`}>
            <ChartBase
              chartType="bar"
              dailyMap={adsMap}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="costMicros"
              label="Advertising costs (Chi phí)"
              unit={currency}
              currency={currency}
              usdRate={usdRate}
            />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
            <ChartBase
              chartType="line"
              dailyMap={adsMap}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="impressions"
              label="Impressions (Lượt hiển thị)"
              unit=""
            />
          </div>
            <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
           <ChartBase
              chartType="bar"
              dailyMap={adsMap}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="clicks"
              label="Clicks (Lượt nhấp)"
              unit=""
            />
          </div>
          </div>
            <div className="row">
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
           <ChartBase
              chartType="line"
              dailyMap={adsMap}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="conversions"
              label="Conversions (Lượt chuyển đổi)"
              unit=""
            />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="bar"
            dailyMap={adsMap}
            startDate={startDate}
            endDate={endDate}
            mode="cal"
            cal1="costMicros"
            cal2="conversions"
            label="CPA (Chi phí / lượt chuyển đổi)"
             unit={currency}
              currency={currency}
              usdRate={usdRate}
          />
          </div>
            <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="line"
            dailyMap={adsMap}
            startDate={startDate}
            endDate={endDate}
            mode="cal"
            cal1="conversions"
            cal2="clicks"
            label="CVR (Tỉ lệ chuyển đổi)"
            unit="%"
          />
          </div>
          </div>
            <div className="row kpi-row">
        <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="bar"
            dailyMap={adsMap}
            startDate={startDate}
            endDate={endDate}
            mode="cal"
            cal1="costMicros"
            cal2="clicks"
            label="CPC (Chi phí / lượt nhấp)"
            unit={currency}
            currency={currency}
            usdRate={usdRate}
          />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="line"
            dailyMap={adsMap}
            startDate={startDate}
            endDate={endDate}
            mode="cal"
            cal1="clicks"
            cal2="impressions"
            label="CTR (Tỉ lệ nhấp)"
            unit="%"
          />
          </div>
           <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="bar"
            dailyMap={adsMap}
            startDate={startDate}
            endDate={endDate}
            mode="cal"
            cal1="costMicros"
            cal2="impressions"
            label="CPM (Chi phí / 1000 lượt hiển thị)"
            unit={currency}
            currency={currency}
            usdRate={usdRate}
            cpm
          />
          </div>
          </div>
          </div>

<div className="d-flex align-items-center" style={{marginTop: 50}}>
            <img src="https://cdn-icons-png.flaticon.com/512/732/732204.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
          <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Analytics Chart</div>
          </div>
           <div className="container-fluid pl-5 pr-5 mt-5" >
        <div className="row">
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`}>
            <ChartBase
              chartType="bar"
              dailyMap={ga4FormattedData}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="activeUsers"
              label="Active Users (Người dùng hoạt động)"
              color="#FF8A00"
              unit=""
            />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
            <ChartBase
              chartType="line"
              dailyMap={ga4FormattedData}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="screenPageViews"
              label="Page Views (Lượt xem trang)"
              color="#FF8A00"   
              unit=""
            />
          </div>
            <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
           <ChartBase
              chartType="bar"
              dailyMap={ga4FormattedData}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="eventCount"
              label="Events (Sự kiện)"
              color="#FF8A00"
              unit=""
            />
          </div>
          </div>
            <div className="row">
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
           <ChartBase
              chartType="line"
              dailyMap={ga4FormattedData}
              startDate={startDate}
              endDate={endDate}
              mode="raw"
              field="sessions"
              label="Sessions (Phiên)"
              color="#FF8A00"
              unit=""
            />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="bar"
            dailyMap={ga4FormattedData}
            startDate={startDate}
            endDate={endDate}
            mode="raw"
            field="totalUsers"
            label="Total Users (Tổng người dùng)"
            color="#FF8A00"
            unit=""
          />
          </div>
            <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
         <ChartBase
            chartType="line"
            dailyMap={ga4FormattedData}
            startDate={startDate}
            endDate={endDate}
            mode="raw"
            field="newUsers"
            label="New Users (Người dùng mới)"
            color="#FF8A00"
            unit=""
          />
          </div>
          </div>
            <div className="row kpi-row">
          </div>
          </div>

            <div className="container-fluid pl-5 pr-5 mt-5" >
        <div className="row">
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
           <ChartSimple 
              type="raw"
              stats={browserStats}
              title = "Browser"
           />
          </div>
          <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
             <ChartSimple 
              type="raw"
              stats={deviceStats}
              title = "Device"
           />
          </div>
            <div className={`col-md-4 mb-4 ${styles.kpi3Col}`} >
          <ChartSimple 
              type="raw"
              stats={osStats}
              title = "Operating System"
           />
          </div>
          </div>
          </div>
      </>

  );
}



